import React, { useEffect, useState } from 'react'
import ListLayout from '../../../../component/listLayout'
import AddButton from '../../../../component/AddButton'
import InputSearch from '../../../../component/InputSearch'
import { Link, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, Button, FormControl, MenuItem, Select } from '@mui/material'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { getCatalogs, getReservesCenterList, updateReserve } from '../../services/api'

export default function ReserveHqList() {
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let c = searchParams.get('c') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || ''
    const [catalog, setCatalog] = useState([])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);
    const [rowsPerPage] = useState(10);
    const { profile } = useSelector(state => state.profile)

    const getCatalogList = async () => {
        const data = await getCatalogs()
        setCatalog(data)
    }
    const getList = async () => {
        setLoading(true)
        const data = await getReservesCenterList(q, c, page, rowsPerPage)
        setData(data)
        setLoading(false)
    }


    async function Close(ReserveNo, RefNo) {
        Swal.fire({
            title: `ยืนยันการยกเลิก: ${RefNo}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4ab866',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                const body = {
                    ReserveNo: ReserveNo,
                    Status: 'C'
                }
                const post = async () => {
                    const res = await updateReserve(body)
                    if (res.status === true) {
                        Swal.fire(
                            'เรียบร้อย',
                            '',
                            'success'
                        )

                        getList()

                    }
                }
                post()
            }
        })

    }
    useEffect(() => {
        getCatalogList()
    }, [])
    useEffect(() => {
        getList()
    }, [q, c, page, rowsPerPage])

    const head = [
        '',
        'ที่',
        'เลขที่หนังสือ',
        'ลงวันที่',
        'ชื่อโครงการ',
        'ผู้สำรอง',
        'ปริมาณ (กิโลกรัม)',
        'สถานะ',
        'ขาย',
        'ดำเนินการ',
    ]
    const body = data?.items?.map((x, i) => {

        return {
            id: x?.ReserveNo,
            item1: x?.SaleStatus === 'N' && (profile?.BranchNo?.BranchNo === x?.BranchNo?.BranchNo) ? <span>NEW!</span> : '',
            item2: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
            item3: x?.RefNo,
            item4: dayjs(x?.DocumentDate).format('DD/MM/BBBB'),
            item5: x?.CampaignName,
            item6: x?.CreateId,
            item7: x?.TotalQty?.toLocaleString(),
            item8: x?.Status === 'Y' ?
                <span class="status-active">
                    ปกติ
                </span> : x?.Status === 'N' ?
                    <span class="status-inactive">
                        ยกเลิก
                    </span> : x?.Status === 'D' ?
                        <span class="status-active">
                            เสร็จสิ้น
                        </span> : x?.Status === 'C' ?
                            <span class="status-draft">
                                ปิด
                            </span> : '',
            item9: x.SaleStatus === 'P' &&
                <span class="status-inactive">
                    ขายไปบางส่วน
                </span>,
            item10: <>
                <Link to={`/stock/reserve-hq/${x?.ReserveNo}`}>
                    <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }} onClick={() => setSearchParams({ id: x?.ReserveNo, page: page, q: q, c: c, })}>เรียกดู</Button>
                </Link>
                {(x?.Status === 'Y') &&
                    <Button onClick={() => Close(x?.ReserveNo, x?.RefNo)} variant='contained' color='error' sx={{ marginLeft: '10px' }}>ปิด</Button>

                }</>
            ,
        }
    })
    return (
        <ListLayout title={'รายการสำรองเมล็ดพันธ์ุ'} action={<>
            {profile?.BranchNo?.BranchNo === '00' && <>
                <AddButton link={'/stock/reserve-hq/add'} />

            </>}
            <div class="col-lg-2 col-md-6">
                <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                    <FormControl variant="standard" fullWidth >
                        <Select value={c || 'all'} onChange={e => setSearchParams({ q: q, c: e.target.value })}
                            disableUnderline
                            MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                        >
                            <MenuItem value='all'>ทุกพันธุ์ข้าว</MenuItem>
                            {catalog?.map((x) => <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
            </div>

            <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value, c: c })} placeholder={"ค้นหา เลขที่เอกสาร"} />
        </>} loading={loading} head={head} body={body} pagination={{
            count: data?.meta?.totalPages,
            page: +page,
            event: { q: q, c: c, id: id }
        }} id={id} setSearchParams={setSearchParams} />
    )
}
